// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separate[data-v-c183c882]{margin-top:70px}.visible-mobile[data-v-c183c882]{display:none}@media(max-width:1023px){.visible-mobile[data-v-c183c882]{display:block}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
